import { useState, type JSX } from 'react';
import { Modal } from '../ui/common.js';
import { api } from '../api/client.js';
import { dateForOffset } from '../state/app.js';
import { timeRangeError } from '../lib/validateRange.js';

const REASONS = ['외근', '회의', '병원', '개인 용무'];

export function AwayModal({ onClose, onDone }: { onClose: () => void; onDone: (msg: string) => void }): JSX.Element {
  const [start, setStart] = useState('14:00');
  const [end, setEnd] = useState('15:30');
  const [reason, setReason] = useState('');
  const [busy, setBusy] = useState(false);
  const today = dateForOffset(0).date;
  const rangeErr = timeRangeError(start, end);

  const submit = async (): Promise<void> => {
    if (rangeErr) return;
    setBusy(true);
    try {
      await api.createAway({
        startTime: `${today}T${start}:00`,
        endTime: `${today}T${end}:00`,
        reason,
      });
      onDone('자리비움이 등록되었습니다');
      onClose();
    } catch (e) {
      onDone(e instanceof Error ? e.message : '등록 실패');
      setBusy(false);
    }
  };

  return (
    <Modal width={400} onClose={onClose}>
      <div style={{ padding: 22 }}>
        <div style={{ fontSize: 17, fontWeight: 700, marginBottom: 18 }}>자리비움 등록</div>
        <div style={{ display: 'flex', gap: 12, marginBottom: 14 }}>
          <label style={field}><span style={lbl}>시작</span><input type="time" className="dx-input" value={start} onChange={(e) => setStart(e.target.value)} /></label>
          <label style={field}><span style={lbl}>종료</span><input type="time" className="dx-input" value={end} onChange={(e) => setEnd(e.target.value)} /></label>
        </div>
        {rangeErr && <div style={rangeErrStyle}>{rangeErr}</div>}
        <div style={{ fontSize: 12, fontWeight: 600, color: '#6B7280', marginBottom: 8 }}>사유</div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 7, marginBottom: 10 }}>
          {REASONS.map((r) => (
            <button key={r} onClick={() => setReason(r)} style={chip(reason === r)}>{r}</button>
          ))}
        </div>
        <input className="dx-input" style={{ width: '100%' }} placeholder="직접 입력" value={reason} onChange={(e) => setReason(e.target.value)} />
        <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
          <button className="dx-btn dx-btn-ghost" style={{ flex: 1 }} onClick={onClose}>취소</button>
          <button className="dx-btn dx-btn-primary" style={{ flex: 1 }} disabled={busy || !!rangeErr} onClick={submit}>등록</button>
        </div>
      </div>
    </Modal>
  );
}

const rangeErrStyle = { background: '#FEF2F2', border: '1px solid #FCA5A5', color: '#B91C1C', borderRadius: 8, padding: '8px 11px', fontSize: 12.5, fontWeight: 600, marginBottom: 12 } as const;
const field = { flex: 1, display: 'flex', flexDirection: 'column', gap: 6 } as const;
const lbl = { fontSize: 12, fontWeight: 600, color: '#6B7280' } as const;
const chip = (active: boolean) => ({
  border: `1px solid ${active ? '#2563EB' : '#D1D5DB'}`, background: active ? '#EFF4FE' : '#fff',
  color: active ? '#1D4ED8' : '#4B5563', fontFamily: 'inherit', fontSize: 13, fontWeight: 600,
  padding: '6px 12px', borderRadius: 7, cursor: 'pointer',
});
